import bg from "@/public/assets/backgroundTexture.jpg"
import { ReactNode } from "react"

interface ComponentProps {
  children: ReactNode,
  
}

export default function MainComponent({ children, ...props }: any) {
  return (
    <main {...props} style={{
      backgroundImage: `url(${bg.src})`,
      backgroundRepeat: "repeat-y",
      backgroundSize: "cover",
      backgroundPosition: 'center'
    }}>
      {children}
    </main>
  )
}